export default {
  header: 'Obnoviť heslo',
  input: 'Vaša emailová adresa',
  success: 'Email s odkazom na zmenu hesla bol odoslaný do vašej emailovej schránky.'
}



// WEBPACK FOOTER //
// ./src/i18n/sk/components/resetPassword.js